import { Currency } from "@/types/models";

type FormatCurrencyProps = {
  number: number;
  currency?: Currency | null;
  locale?: string;
};

export const FormatCurrency = ({
  number,
  currency = "GBP",
  locale = "en-GB",
}: FormatCurrencyProps) => {
  return new Intl.NumberFormat(locale, {
    style: "currency",
    currency: currency || "GBP",
    maximumFractionDigits: number % 1 === 0 ? 0 : 2,
  }).format(number);
};
